export default {
  resource:{
    zh: {
      title:"部门",
      companyNo: "公司",
      companyName: "公司",
      deptNo: "部门编号",
      deptName: "部门",
      head:	"负责人",
      baseNumber:"配置人数",
      pnumber:	"人数",
      remark:	"备注",
      group:"组别",
      defaultGroup:"默认组",
      job:"岗位",
      nullId:"部门序号不能为空！",
      nullName:"部门名称不能为空！",
      alExists:"部门序号或名称已经存在，请检查！",
      is_show:"B帐显示",
      nameExist:"部门已经存在，请检查！"
    }
  },
  delConf:["deptName"],
  delKeys:["autoid"],
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options:"company"
    },
    deptNo:{
      key: "deptNo",
      data: null,
      method: "Equal",
      type: "number"
    },
    deptName:{
      key: "deptName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [    
    "companyName","deptNo","deptName","head","baseNumber","pnumber","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"deptNo",
  defaultSortOrder:"asc",
  sortName: "deptNo",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "dept/",
  autoId: "autoid"

}
